import { useState, useEffect, useCallback } from 'react';
import useAlert from '../Alerts/useAlert';
import { useHttpUtils } from '../Utilities/useHttpUtils';

export const useGrades = (businessUnitCode) => {

    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();

    const [loading, setLoading] = useState(false);
    const [grades, setGrades] = useState([]);

    const getGrades = useCallback((businessUnitCode) => {
        if (!loading && businessUnitCode) {
            setLoading(true);

            fetchDataAuthenticated(`api/v1/grade?businessUnitCode=${businessUnitCode}`)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error("Failed to get grades for business unit");
                    }
                })
                .then(data => setGrades(data))
                .catch(error => {
                    setAlert("danger", "Error", error.message);
                })
                .finally(() => setLoading(false));
        }
    }, [fetchDataAuthenticated, loading, setAlert]);

    useEffect(() => {
        getGrades(businessUnitCode);
    }, [businessUnitCode]);

    return { grades, loading };
}

export const useAlternativeGrades = (lotNumber) => {

    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();

    const [loading, setLoading] = useState(false);
    const [alternativeGrades, setAlternativeGrades] = useState([]);

    const getAlternativeGrades = useCallback((lotNumber) => {
        if (!loading) {
            setLoading(true);

            fetchDataAuthenticated(`api/v1/grade/lot?lotNumber=${lotNumber}`)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw new Error("Failed to get alternative grades for lot");
                    }
                })
                .then(data => setAlternativeGrades(data))
                .catch(error => {
                    setAlert("danger", "Error", error.message);
                })
                .finally(() => setLoading(false));
        }
    }, [fetchDataAuthenticated, loading, setAlert]);

    useEffect(() => {
        getAlternativeGrades(lotNumber);
    }, [lotNumber]);

    return { alternativeGrades, loading };
}